module.exports = __webpack_public_path__ + "141d4a85/img/grid-web-icon.d0395d64.svg";